// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__Qwdx7","primary":"Button_primary__RgXDX"};